import axios from "axios";

export const fetchCustomerEventDiscount = async (branchId, subTotal) => {
  const response = await axios.post(
    `${process.env.REACT_APP_API_URL}/event-discount/customer`,
    { branch_id: branchId },
    { headers: { ContentType: "application/json" } }
  );
  if (!response.data?.success) {
    return { amount: 0, name: null };
  }
  const res = response.data.data?.length > 0 ? response.data.data[0] : null;
  if (!res) {
    return { amount: 0, name: null };
  }
  const max = Number(res.discount?.max) || 0;
  const percent = Number(res.discount?.percent) || 0;
  const fixed = Number(res.discount?.amount) || 0;
  const base = Number(subTotal) || 0;
  let discount = fixed;
  if (max > 0) {
    const calculated = (base * percent) / 100;
    discount += calculated > max ? max : calculated;
  } else {
    discount += (base * percent) / 100;
  }
  const finalDiscount = Number(discount);
  if (Number.isNaN(finalDiscount) || finalDiscount <= 0) {
    return { amount: 0, name: null };
  }
  return {
    amount: finalDiscount,
    name: res.name || res.discount?.name || null,
  };
};
